export const styleConstant = {
  siteNavigationComponentHeight: "70px",
  titleComponentHeight: "70px"
};
